import { TestCellArray, TestCellObj } from './initializer';

type StructureTestCells = (TestCell: TestCellArray | TestCellObj | undefined) => TestCellArray | undefined;

export const structureTestCells: StructureTestCells = (testCells) => {
    let structureTestCells
    // If incoming test cells are in a hash map, convert to array:
    if (!Array.isArray(testCells) && typeof testCells === 'object') {
        structureTestCells = Object.entries(testCells)
            .reduce((testCellArray: TestCellArray, [layer, cell]) => {
                testCellArray.push({ layer, cell });
                return testCellArray;
            }, [])
    } else {
        structureTestCells = testCells;
    }
    return structureTestCells;
}
